// TiaraTrackPage(pageName, viewName) → GA4 page_view 이벤트
export function GoogleAnalyticsTrackPage(viewName) {
  window.gtag?.('event', 'page_view', {
    page_title: viewName,
    page_location: window.location.href, // 현재 페이지
    page_referrer: window.location.origin, // 이전 페이지
  })
}

// TiaraTrackSearch(term, type) → GA4 search 이벤트
export function GoogleAnalyticsTrackSearch(searchTerm, searchType) {
  window.gtag?.('event', 'search', {
    search_term: searchTerm,
    search_type: searchType,
  })
}

// GA4 클릭 이벤트
export function GoogleAnalyticsTrackClick(actionName, actionKind) {
  window.gtag?.('event', 'click', {
    event_category: actionKind,
    event_label: actionName,
  })
}